import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { ManagedPortfolioType } from "./ManagedPortfolioService";
import { TRatiosCarterasDBModel } from "../screen/Portfolios/File/types/CarteraRatioTypes";
setupInterceptorsTo(axios);

interface IFinametrixContraccType
{
    id?: number,
    finametrixId?: string,
    name?: string
}
interface IFnmContract
{
    id?: number,
    completed: boolean,
    finametrixContractId?: string,
    finametrixContract?: string,
    finametrixContraccType?: IFinametrixContraccType,
    createdAt?: string,
    updatedAt?: string
}
interface IPortfolio
{
    id?: number,
    finametrixId?: string,
    fnmContract: IFnmContract,
    managedPortfolio: ManagedPortfolioType,
    createdAt?: string,
    updatedAt?: string
}
export type PortfolioType = IPortfolio
export type FnmContractType = IFnmContract

class PortfolioService
{
    public getPortfolio = async (portfolioId: number): Promise<PortfolioType> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios/${portfolioId}`
        const req = await axios.get<any>(url)
        return req.data
    }
    public createPortfolio = async (portfolio: PortfolioType): Promise<PortfolioType> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios`
        const req = await axios.post(url, portfolio)
        return req.data
    }
    public getPortfoliosByUserIdentityId = async (userIdentityId: number): Promise<PortfolioType[]> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios/getByUserIdentityId/${userIdentityId}`
        const req = await axios.get(url)
        return req.data
    }
    public getRatioCarteraByNomcontrato = async (nomcontrato: string): Promise<TRatiosCarterasDBModel[]> => {
        let url: string = `${proxyUrl}/ratioscarteras/getByNomcontrato/${nomcontrato}`
        const req = await axios.get(url)
        return req.data
    }
    public getRatioCarteraByRatioAndPeriodAndNomcontrato = async ({ratio, period, nomcontrato} : {ratio: string, period: string, nomcontrato: string}): Promise<TRatiosCarterasDBModel[]> => {
        let url: string = `${proxyUrl}/ratioscarteras/getByRatioAndPeriodAndNomcontrato/${ratio}/${period}/${nomcontrato}`
        const req = await axios.get(url)
        return req.data
    }
}

const portfolios = new PortfolioService();
export default portfolios;